<!--  -->
<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      size="mini"
      style="margin-bottom:20px"
      @click="addregion"
    >新增区域</el-button>
    <el-form
      :label-position="labelPosition"
      label-width="80px"
    >
      <el-form-item
        v-for="item,index in names"
        :key="index"
        :label="'活动区域'+ (index+1) "
      >
        <el-input
          v-model="item.name"
          class="activity_sty"
          @blur="activebluer(index)"
        />
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          style="margin-left:20px"
          @click="deleteregion(index)"
        >删除区域</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="qundwrok"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { checkarea, removearea } from '@/api/report/accountManagement'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      account_ids: [],
      names: [
        {
          name: ''
        }
      ],
      chuannames: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(account_ids) {
      console.log('account_ids', account_ids)
      this.account_ids = []
      this.account_ids = account_ids
    },
    addregion() {
      this.names.push({ name: '' })
    },
    deleteregion(index) {
      this.names.splice(index, 1)
    },
    activebluer(index) {
      console.log('index', index)
      if (this.names[index].name === '') {
        return
      }
      checkarea({
        name: this.names[index].name
      })
        .then(res => {
          console.log('res', res)
        })
        .catch(error => {
          this.names[index].name = ''
          console.log('error', error)
        })
    },
    qundwrok() {
      const flag = this.names.every(function(a) {
        return a.name !== ''
      })
      if (flag === false) {
        this.$message.error('请填写区域')
        return
      }
      this.chuannames = []
      this.chuannames = this.names.map(item => {
        return item.name
      })
      removearea({
        account_ids: this.account_ids,
        names: this.chuannames
      }).then(res => {
        console.log('res', res)
        this.$message({
          message: `${res.message}`,
          type: 'success'
        })
        this.$emit('callbatchremova')
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.activity_sty {
  width: 300px;
}
</style>
